import { FC } from 'react'
import {
  Text,
  IconUser,
  IconXMark,
  BorderRadius6,
  Button,
  GreyGrey20,
  GreyGrey70,
  GreyGrey80,
  Primary13Regular,
  Center,
  Flex
} from '@sequencehq/core-components'

export const ApproverItem: FC<{
  email: string
  onDelete: () => void
  'data-testid'?: string
}> = ({ email, onDelete, 'data-testid': dataTestId }) => {
  return (
    <Flex
      data-testid={dataTestId}
      backgroundColor={GreyGrey20}
      gap="4px"
      padding="8px"
      borderRadius={BorderRadius6}
      width="fit-content"
      maxWidth="100%"
    >
      <Center width="16px" height="16px" flexShrink="0">
        <IconUser color={GreyGrey70} />
      </Center>

      <Text
        {...Primary13Regular}
        color={GreyGrey80}
        noOfLines={1}
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
      >
        {email}
      </Text>

      <Button
        variant="unstyled"
        onClick={onDelete}
        data-testid={dataTestId ? `${dataTestId}.delete` : undefined}
      >
        <IconXMark color={GreyGrey70} />
      </Button>
    </Flex>
  )
}
